import { render, staticRenderFns } from "./StockRemainQuery.vue?vue&type=template&id=94a69122&scoped=true&"
import script from "./StockRemainQuery.vue?vue&type=script&lang=js&"
export * from "./StockRemainQuery.vue?vue&type=script&lang=js&"
import style0 from "./StockRemainQuery.vue?vue&type=style&index=0&id=94a69122&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94a69122",
  null
  
)

export default component.exports